export abstract class Anagrafica {
  id: string;
  abstract getAnagraficaTAG(): string;
}
